module.exports = "<div class=modal tabindex=-1 role=dialog> <div class=\"modal-dialog cenceo-video-modal-dialog\"> <div class=modal-content> <div class=modal-body> <video controls=\"\" width=640 height=480 autoplay> <source ng-src=\"{{videoUrl | trustUrl}}\" type=video/mp4> </video> </div> </div> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-movie-button/video-modal.tpl.html
 ** module id = 73
 ** module chunks = 0
 **/